import { SectionLabel, PrimaryButton } from "@/components/Bits";
import { SpinningWheel } from "@/components/SpinningWheel";

const IMG_ATHLETE =
  "https://images.unsplash.com/photo-1710736460914-4a7f22d736c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxhdGhsZXRpYyUyMHRyYWluaW5nfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc4MjAzNzQ2OXww&ixlib=rb-4.1.0&q=85";

const values = [
  { k: "Clinical", v: "Measure, test, improve. No noise, no hiding behind the bush." },
  { k: "High Contrast", v: "Clear standards, attainable goals, and honest conversations — black and white." },
  { k: "Modern", v: "Lean systems and contemporary solutions that solve real problems." },
  { k: "Sustainable", v: "Built for generations to come." },
];

export default function About() {
  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="border-b border-[#E5E5E5]">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-20 md:py-28">
          <SectionLabel index="01">About ZONA Sports</SectionLabel>
          <h1 className="mt-8 max-w-4xl font-heading font-bold uppercase leading-[0.95] tracking-tighter text-[#111111] text-5xl md:text-7xl">
            Improving the world through sport
          </h1>
          <p className="mt-8 max-w-2xl text-[#333333] text-base md:text-lg leading-relaxed">
            Our mission is simple and relentless: improve the sporting world, and in doing so,
            improve the world itself.
          </p>
        </div>
      </section>

      {/* MISSION + WHEEL */}
      <section className="mx-auto max-w-7xl px-6 md:px-10 py-20 md:py-28">
        <div className="grid items-center gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <SectionLabel index="02">The Mission</SectionLabel>
            <h2 className="mt-6 font-heading font-bold uppercase tracking-tight text-[#111111] text-3xl md:text-5xl leading-tight">
              One wheel, never stopping
            </h2>
            <p className="mt-6 text-[#333333] text-base md:text-lg leading-relaxed">
              Education, Infrastructure, and Development are interconnected, forming three spokes
              on a single wheel. Each accelerates the next, creating a cycle of momentum. We raise
              standards through education, build infrastructure to support and expand those
              standards, and develop people and pathways to ensure sustained value and continuous
              progress, making each rotation of the wheel stronger than the last.
            </p>
          </div>
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <SpinningWheel size={320} />
          </div>
        </div>
      </section>

      {/* IMAGE BAND */}
      <section className="relative h-[300px] md:h-[420px] border-y border-[#E5E5E5] overflow-hidden">
        <img src={IMG_ATHLETE} alt="Athlete" className="absolute inset-0 h-full w-full object-cover grayscale" />
        <div className="absolute inset-0 bg-[#111111]/30" />
        <div className="relative mx-auto flex h-full max-w-7xl items-end px-6 md:px-10 py-10">
          <p className="max-w-lg font-heading text-white uppercase tracking-tight text-2xl md:text-3xl leading-tight">
            Performance starts with focus. Standards start with us.
          </p>
        </div>
      </section>

      {/* VALUES */}
      <section className="mx-auto max-w-7xl px-6 md:px-10 py-20 md:py-28">
        <SectionLabel index="03">How we work</SectionLabel>
        <div className="mt-12 grid gap-px bg-[#E5E5E5] sm:grid-cols-2 border border-[#E5E5E5]">
          {values.map((item) => (
            <div key={item.k} className="bg-white p-10" data-testid={`value-${item.k.toLowerCase()}`}>
              <h3 className="font-heading font-bold uppercase tracking-tight text-2xl text-[#111111]">
                {item.k}
              </h3>
              <p className="mt-4 text-[#333333] leading-relaxed">{item.v}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="border-t border-[#E5E5E5]">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-20 text-center">
          <h2 className="font-heading font-bold uppercase tracking-tight text-[#111111] text-3xl md:text-5xl">
            Want to be part of it?
          </h2>
          <div className="mt-10 flex justify-center">
            <PrimaryButton to="/contact" testid="about-cta">Get in touch</PrimaryButton>
          </div>
        </div>
      </section>
    </div>
  );
}
